import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const ofertasModule = {
    state: {
        ofertas: [],
        ofertasInternacionales: [],
        ofertasEstudiaTrabaja: [],
        practicasAsignadas: ''
    },
    getters: {
        getofertas: state => state.ofertas,
        getofertasinternacionales: state => state.ofertasInternacionales,
        getofertasEstudiaTrabaja: state => state.ofertasEstudiaTrabaja,
        getPracticasAsignadas: state => state.practicasAsignadas
    },
    actions: {
        requestOfertas({ commit, dispatch }) {
            return new Promise((resolve, reject) => {

                axios.get('/api/Alumno/dameOfertas/1').then(result => {

                    if (result.data.status == 0) {

                        if (result.data.datos.numPaginas != 1) {
                            let data = {
                                max: result.data.datos.numPaginas,
                                page: 2
                            }
                            dispatch('requestMoreOfertas', data);
                        }
                        commit('addOfertas', result.data.datos.ofertas)

                    } else {
                        commit('setError', result.data.status)
                        reject(false);
                    }

                }).catch(error => {

                });
            });
        },
        requestMoreOfertas({ commit, dispatch }, data) {

            return new Promise((resolve, reject) => {

                if (data.page <= data.max) {

                    axios.get('/api/Alumno/dameOfertas/' + data.page).then(result => {

                        if (result.data.status == 0) {
                            commit('addOfertas', result.data.datos.ofertas);
                            data.page++;
                            console.log(data);
                            dispatch('requestMoreOfertas', data);
                            resolve(true);
                        } else {
                            commit('setError', result.data.status)
                            reject(false);
                        }

                    }).catch(error => {

                    });

                } else {
                    resolve(true)
                }
            });
        },
        requestOferta({ commit }, slug) {
            return new Promise((resolve, reject) => {

                axios.get('/api/Alumno/dameOferta/' + slug).then(result => {
                    if (result.data.status == 0) {
                        resolve(result.data.datos);
                    } else {
                        commit('setError', result.data.status)
                        reject(false);
                    }
                }).catch(error => {
                    reject(false);
                });
            });
        },
        requestProgramaIndependiente({ commit }, slug) {
            return new Promise((resolve, reject) => {

                axios.get('/api/Alumno/detalleProgramaIndependiente/' + slug).then(result => {
                    if (result.data.status == 0) {
                        resolve(result.data.datos);
                    } else {
                        commit('setError', result.data.status)
                        reject(false);
                    }
                }).catch(error => {
                    reject(false);
                });
            });
        },
        inscribirmeOferta({ commit, dispatch }, data) {
            return new Promise((resolve, reject) => {
                axios.post('/api/Alumno/inscribirseOferta', data).then(result => {
                    if (result.data.status == 0) {
                        resolve(true);
                        commit('setError', 600);
                        dispatch('requestCandidaturas');
                    } else if (result.data.status == 11) {
                        resolve(result.data.datos.documentacionNecesaria);
                    } else {
                        reject(result.data.mensaje);
                    }
                }).catch(error => {
                    reject(false);
                });
            });
        },
        requestPracticasAsignadas({ commit }) {
            return new Promise((resolve, reject) => {

                axios.get('/api/Alumno/damePracticas').then(result => {
                    if (result.data.status == 0) {
                        commit('setPracticasAsignadas', result.data.datos);
                        resolve(true);
                    } else {
                        commit('setError', result.data.status)
                        reject(false);
                    }
                }).catch(error => {
                    reject(false);
                });
            });
        },
        requestOfertasInternacionales({ commit, dispatch }) {
            return new Promise((resolve, reject) => {

                axios.get('/api/Alumno/dameOfertasInternacionales/1').then(result => {

                    if (result.data.status == 0) {

                        if (result.data.datos.numPaginas != 1) {
                            let data = {
                                max: result.data.datos.numPaginas,
                                page: 2
                            }
                            dispatch('requestMoreOfertas', data);
                        }
                        commit('addOfertasInternacionales', result.data.datos.ofertas)

                    } else {
                        commit('setError', result.data.status)
                        reject(false);
                    }

                }).catch(error => {

                });
            });
        },
        requestMoreOfertasInternacionales({ commit, dispatch }, data) {

            return new Promise((resolve, reject) => {

                if (data.page <= data.max) {

                    axios.get('/api/Alumno/dameOfertasInternacionales/' + data.page).then(result => {

                        if (result.data.status == 0) {
                            commit('addOfertasInternacionales', result.data.datos.ofertas);
                            data.page++;
                            dispatch('requestMoreOfertasInternacionales', data);
                            resolve(true);
                        } else {
                            commit('setError', result.data.status)
                            reject(false);
                        }

                    }).catch(error => {

                    });

                } else {
                    resolve(true)
                }
            });
        },
        requestOfertasEstudiaTrabaja({ commit, dispatch }) {
            return new Promise((resolve, reject) => {

                axios.get('/api/Alumno/dameOfertasEstudiaYtrabaja/1').then(result => {

                    if (result.data.status == 0) {

                        if (result.data.datos.numPaginas != 0) {
                            if (result.data.datos.numPaginas != 1) {
                                let data = {
                                    max: result.data.datos.numPaginas,
                                    page: 2
                                }
                                dispatch('requestMoreOfertasEstudiaTrabaja', data);
                            }
                            commit('addOfertasEstudiaTrabaja', result.data.datos.ofertas)

                        } else {
                            resolve(true);
                        }

                    } else {
                        commit('setError', result.data.status)
                        reject(false);
                    }

                }).catch(error => {

                });
            });
        },
        requestMoreOfertasEstudiaTrabaja({ commit, dispatch }, data) {

            return new Promise((resolve, reject) => {

                if (data.page <= data.max) {

                    axios.get('/api/Alumno/dameOfertasEstudiaYtrabaja/' + data.page).then(result => {

                        if (result.data.status == 0) {
                            commit('addOfertasEstudiaTrabaja', result.data.datos.ofertas);
                            data.page++;
                            dispatch('requestMoreOfertasEstudiaTrabaja', data);
                            resolve(true);
                        } else {
                            commit('setError', result.data.status)
                            reject(false);
                        }

                    }).catch(error => {

                    });

                } else {
                    resolve(true)
                }
            });
        },
    },
    mutations: {
        addOfertas(state, ofertas) {

            if (!state.ofertas.some(o => o.urlAcceso == ofertas[0].urlAcceso)) {
                state.ofertas = state.ofertas.concat(ofertas);
            }
        },
        addOfertasInternacionales(state, ofertas) {
            if (!state.ofertasInternacionales.some(o => o.urlAcceso == ofertas[0].urlAcceso)) {
                state.ofertasInternacionales = state.ofertasInternacionales.concat(ofertas);
            }
        },
        addOfertasEstudiaTrabaja(state, ofertas) {
            if (!state.ofertasEstudiaTrabaja.some(o => o.urlAcceso == ofertas[0].urlAcceso)) {
                state.ofertasEstudiaTrabaja = state.ofertasEstudiaTrabaja.concat(ofertas);
            }
            
        },
        setPracticasAsignadas(state, ofertas) {
            state.practicasAsignadas = ofertas;
        }
    }
}

export default ofertasModule;


// WEBPACK FOOTER //
// ./src/store/ofertasModule.js